module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"KODE","short_name":"KODE","start_url":"/","background_color":"#4F4FF4","theme_color":"#4F4FF4","display":"standalone","icon":"static/images/splash-logo.svg","include_favicon":false,"crossOrigin":"use-credentials"},
    },{
      plugin: require('../node_modules/gatsby-plugin-yandex-metrika/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":65768221,"webvisor":true,"trackHash":true,"afterBody":true,"defer":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
